export default "__VITE_ASSET__BYLiUEbn__"